export default "__VITE_ASSET__Com9mXYl__"